<template>
    <div class="myCompany">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="content">
            <div class="mtop20" v-for="item in companyList" :key="item.id">
                <van-swipe-cell v-if="item.isAdmin">
                    <div class="myCompany" :class="{'isChecked': item.isChecked, 'stop': !item.isEnabled}"  @click="onSwitch(item)">
                        <div class="name">{{ item.companyName }}
                            <span class="verifiedClass" :class="rzStatus[item.authenticationStatus - 1].class">{{ rzStatus[item.authenticationStatus - 1].rzName }}</span>
                            <span class="verifiedClass" :class="rzStatus[item.openStatus - 1].class">{{ rzStatus[item.openStatus - 1].openName }}</span>
                            <span v-if="!item.isEnabled" class="verifiedClass enabled">已禁用</span>
                        </div>
                        <p>经营区域：{{ item.provinceName + ' ' + item.cityName + ' ' + item.countryName }}</p>
                        <div class="tab">
                            <span>管理员</span><span v-for="(it, idx) in item.roleNames" :key="idx" v-text="it.roleName"></span>
                            <div class="rz" v-show="item.authenticationStatus === 1 || item.authenticationStatus === 4 || item.openStatus === 1" @click.stop="onApprove(item)">{{ (item.authenticationStatus === 3 && item.openStatus === 1) ? '去开户' : '去认证' }}</div>
                            <div class="rz" v-show="(item.authenticationStatus === 3) && (item.openStatus === 4)" @click.stop="openResult(item)">去查看</div>
                            <div class="rz" v-show="item.userType === 11 && item.authenticationStatus !== 1" @click.stop="onUpgrade(item)">升级</div>
                        </div>
                    </div>
                    <template slot="right" v-if="item.isEnabled && item.authenticationStatus !== 3">
                        <van-button square type="danger" color='#FF3B30' @click="onEdit(item)" text="编辑" />
                    </template>
                </van-swipe-cell>
                <van-swipe-cell v-else>
                    <div class="myCompany" :class="{'isChecked': item.isChecked, 'stop': !item.isEnabled}" @click="onSwitch(item)">
                        <div class="name">{{ item.companyName }}
                            <span v-if="!item.isEnabled" class="verifiedClass enabled">已禁用</span>
                        </div>
                        <p>经营区域：{{ item.provinceName }} {{ item.cityName }} {{ item.countryName }}</p>
                        <div class="tab"><span v-for="(it, idx) in item.roleNames" :key="idx" v-text="it.roleName"></span></div>
                    </div>
                    <template slot="right">
                        <van-button square type="danger" color='#FF3B30' @click="onEsc(item)" text="退出该企业" />
                    </template>
                </van-swipe-cell>
            </div>
            <div class="mtop20" v-if="isAdmin">
                <div class="myCompany create" @click="onCompany">
                    <div class="name">创建企业</div>
                </div>
            </div>
        </div>
        <TipMessage
            :visibleShow.sync='visibleShow'
            @onConfirm='onConfirm'
        >
            <div class="openMessage">{{ messageTip }}</div>
        </TipMessage>
        <Popup ref="pop"></Popup>
        <StopPopup ref="popStop"></StopPopup>
    </div>
</template>
<script>
import Header from '../../common/header'
import Popup from '../common/popup'
import StopPopup from '../common/stopPopup'
import TipMessage from '../common/tipMessage'
import { Dialog, Toast } from 'vant'
import { mapActions } from 'vuex'
import { checkAuthInfo, isUpgrade } from '../api/payment'
export default {
    name: 'company',
    components: {
        Header,
        Popup,
        StopPopup,
        TipMessage
    },
    data () {
        return {
            title: '我的企业',
            show: true,
            isAdmin: 0,
            userInfo: '',
            companyList: '',
            messageTip: '',
            visibleShow: false,
            assetsData: {},
            upgradeData: {},
            rzStatus: [
                { class: 'unverified', rzName: '未认证', openName: '未开户' },
                { class: 'underReview', rzName: '认证中', openName: '开户中' },
                { class: 'verified', rzName: '认证成功', openName: '开户成功' },
                { class: 'loser', rzName: '认证失败', openName: '开户失败' }
            ]
        }
    },
    methods: {
        ...mapActions(['getCompanyList', 'outCompany', 'getUserInfoData', 'setSwitch', 'getToken']),
        onBack () {
            this.$router.replace({ path: '/b2b/order/index' })
        },
        onCompany () {
            this.$router.push({ path: '/b2b/initPage/create' })
        },
        openResult (item) {
            this.$router.push({ path: '/b2b/business/errorResult', query: { companyCode: item.companyCode } })
        },
        onUpgrade (item) {
            this.messageTip = '升级为企业会员'
            this.upgradeData = item
            this.visibleShow = !this.visibleShow
        },
        async onConfirm () {
            await isUpgrade({
                companyCode: this.userInfo.companyCode
            })
            this.$router.push({ path: '/b2b/business/open', query: { userType: 12 } })
        },
        async onApprove (item) {
            if (!item.isEnabled) {
                return false
            }
            if (item.authenticationStatus === 3 && item.openStatus === 1) {
                const { data } = await checkAuthInfo({
                    companyCode: item.companyCode
                })
                data.userType * 1 === 11
                    ? localStorage.setItem('openAccountInfo', JSON.stringify(data.individual))
                    : localStorage.setItem('openAccountInfo', JSON.stringify(data.corporation))
                this.$router.push({ path: '/b2b/business/openStatus', query: { userType: data.userType } })
                return
            }
            if (item.authenticationStatus === 4) {
                this.$router.push({ path: '/b2b/business/open', query: { userType: item.userType } })
                return
            }
            this.$refs.pop.onShow()
        },
        onEdit (item) {
            if (!item.isEnabled) {
                return false
            }
            localStorage.setItem('companyData', JSON.stringify(item))
            this.$router.push({ path: '/b2b/company/editCompany' })
        },
        onEsc (item) {
            if (!item.isEnabled) {
                return false
            }
            Dialog.confirm({
                title: '退出该企业？',
                message: '退出企业后您在该企业的信息将会清除，你确定要退出吗？',
                confirmButtonText: '确定退出',
                cancelButtonColor: '#FF7A45',
                confirmButtonColor: '#FF7A45'
            }).then(async () => {
                await this.outCompany({
                    companyCode: item.companyCode,
                    updateBy: this.userInfo.phone,
                    userId: this.userInfo.id
                }).then(async (data) => {
                    Toast('退出成功')
                    this.resetStart()
                })
            }).catch(() => {
            // on cancel
            })
        },
        async onSwitch (item) {
            if (!item.isEnabled) {
                // this.$refs.popStop.onShow()
                return false
            }
            if (item.isChecked) {
                return false
            }
            await this.setSwitch({
                companyCode: item.companyCode,
                userId: this.userInfo.id
            }).then((data) => {
                Toast('切换企业成功')
                this.resetStart()
            })
        },
        async resetStart () {
            await this.getToken({}).then(async (data) => {
                await this.init()
                await this.getUserInfoData()
            })
        },
        async init () {
            await this.getCompanyList().then((data) => {
                this.companyList = data
                let isAdmin = data.map(item => {
                    if (item.isAdmin == 1) {
                        return true
                    }
                })
                this.isAdmin = isAdmin.indexOf(true) < 0 ? 1 : 0
            })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.init()
    }
}
</script>
<style lang="scss" scoped>
    .content{
        .myCompany {
            padding: 32px 24px;
            padding-left: 72px;
            background: #ffffff;
            font-size: 32px;
            border-radius: 12px;
            position: relative;
            .name{
                line-height: 44px;
                .verifiedClass{
                    padding: 0 10px;
                    font-size: 24px;
                    height: 36px;
                    line-height: 36px;
                    margin-left: 16px;
                    text-align: center;
                    display: inline-block;
                    position: relative;
                    border: 2px solid #8E8E90;
                    border-radius: 36px;
                    &.verified{
                        color: #14C2C3;
                        background: #E2F9F9;
                        border-color: #B8ECED;
                    }
                    &.unverified{
                        color: #B3B3B3;
                        background: #F0F0F0;
                        border-color: #E6E6E6;
                    }
                    &.underReview{
                        color: #FA8C16;
                        background: #FFF3E6;
                        border-color: #FDDCB9;
                    }
                    &.loser{
                        color: #FF3B30;
                        background: #FFEDED;
                        border-color: #FFC4C0;
                    }
                    &.enabled{
                        color: #ffffff;
                        background: #B8B8B8;
                        border-color: #B8B8B8;
                    }
                }
                // .enabled{
                //     width: 40px;
                //     height: 40px;
                //     background: url('../../../assets/img/b2b/icon_disable@2x.png') no-repeat;
                //     background-size: 100% 100%;
                //     display: inline-block;
                //     vertical-align: bottom;
                //     margin-left: 20px;
                // }
            }
            // &.isChecked::after{
            //     content: '';
            //     position: absolute;
            //     width: 32px;
            //     height: 32px;
            //     top: 50%;
            //     right: 32px;
            //     transform: translateY(-50%);
            //     background: url('../../../assets/img/b2b/radiobox_p@2x.png') no-repeat;
            //     background-size: 100% 100%;
            // }
            p{
                font-size: 24px;
                margin-top: 4px;

                margin-bottom: 24px;
                line-height: 34px;
                color: #8E8E90;
            }
            .tab{
                color: #808080;
                overflow: hidden;
                span{
                    margin-right: 20px;
                    font-size: 24px;
                    display: inline-block;
                    height: 40px;
                    line-height: 40px;
                    padding: 0 20px;
                    background: #F0F0F0;
                }
                .rz{
                    float: right;
                    font-size: 24px;
                    color: #ffffff;
                    background: #FF7A45;
                    line-height: 48px;
                    border-radius: 32px;
                    padding: 0 28px;
                    margin-left: 16px;
                    padding-right: 50px;
                    position: relative;
                    &::after{
                        position: absolute;
                        content: '';
                        top: 5px;
                        right: 10px;
                        width: 40px;
                        height: 40px;
                        background: url('../../../assets/img/b2b/icon_back_white@2x.png') no-repeat;
                        background-size: 100% 100%;
                        transform: rotate(180deg);
                    }
                }
            }
            &.create::before{
                content: '';
                position: absolute;
                left: 24px;
                top: 34px;
                width: 40px;
                height: 40px;
                background: url('../../../assets/img/b2b/icons_add_orange@2x.png') no-repeat;
                background-size: 100% 100%;
            }
            &::before{
                content: '';
                position: absolute;
                left: 24px;
                top: 34px;
                width: 40px;
                height: 40px;
                background: url('../../../assets/img/b2b/check7.png') no-repeat;
                background-size: 100% 100%;
            }
            &.stop{
                .name{
                    opacity: 0.5;
                }
                &::before{
                    opacity: 0.5;
                }
            }
        }
    }
    /deep/ .van-button{
        height: 100%;
        width: 80px;
    }
    /deep/ .van-button--normal{
        padding: 0 30px;
        box-sizing: content-box;
        font-size: 24px;
    }
</style>